import {createAemClient} from '@uwm/aem';

export default createAemClient({
    graphqlEndpoint: 'dcxconnex-experience-coach',
    damPath: 'dcxconnex/experience-coach',
    localAssetsHost: 'https://experience-coach.icpwa-dev.aws.pmicloud.biz',
});
